<template>
  <thead
    :class="{ 'sticky top-0 z-10': stickyHeader }"
    class="bg-secondary border-b border-secondary"
  >
    <tr>
      <th class="pl-5 w-[44px] h-[36px]" v-if="isSelectable">
        <Checkbox
          size="sm"
          :checked="selectAllValue"
          :indeterminate="true"
          @update:checked="emit('update:selection', 'all')"
          @click.stop
        />
      </th>
      <HeaderCell
        v-for="(column, key) in visibleColumns"
        :key="`column-${key}`"
        :style="{ width: column.props.size + 'px' }"
        :label="column.props.label"
        :field="column.props.field"
        :isSortable="column.props.isSortable"
        :orderBy="orderBy"
        :sortBy="sortBy"
        :class="{ 'pl-1': first(visibleColumns) === column }"
        @update:sort="handleSort"
      />
    </tr>
  </thead>
</template>

<script setup>
// Import Components
import { Checkbox } from "@/SharedComponents/Checkboxes";
import { HeaderCell } from "@/SharedComponents/DataGrid";
import { first } from "lodash";

// Emits
const emit = defineEmits(["update:sort", "update:selection"]);

// Define Props
defineProps({
  visibleColumns: {
    type: Array,
    required: true,
  },
  isSelectable: {
    type: Boolean,
    default: false,
  },
  stickyHeader: {
    type: Boolean,
    default: true,
  },
  selectAllValue: {
    type: [Boolean, String],
    default: false,
  },
  sortBy: {
    type: String,
    default: "",
  },
  orderBy: {
    type: String,
    default: "desc",
  },
});

// Functions
const handleSort = (field, order) => {
  emit("update:sort", field, order);
};
</script>
